<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH"><span class="ePub-B">Contents</span></p>
<p class="CFMH"><span class="ePub-I"><span href="#/xhtml/title" title="Link target outside of Sample">Title Page</span></span></p>
<p class="CFMH"><span class="ePub-I"><span href="#/xhtml/copyrightnotice" title="Link target outside of Sample">Copyright Notice</span></span></p>
<p class="CFMH"><span class="ePub-I"><a href="#/xhtml/epigraph">Epigraph</a></span></p>
<p class="CFMH"> </p>
<p class="CCT"><span class="ePub-B"><a href="#/xhtml/chapter1#ch1">Tosca</a></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Seiche</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Blowing Shades</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Waiting</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Four Deuces</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Caller</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Oceanic</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">If I Vanished</span></span></p>
<p class="CCT"><span class="ePub-B"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Paper Lantern</span></span></p>
<p class="CBMH"> </p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/adcard" title="Link target outside of Sample">Also by Stuart Dybek</span></span></p>
<p class="CBMH"><span class="ePub-I"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3156f6bc